module.exports = __webpack_public_path__ + "src/assets/img/orekhovskaya.9db39a18.jpg";